import moment from "moment";

export const isTokenExpired = () => {
  const tokenExpired = localStorage.getItem('token_expired')

  if (!tokenExpired) return true

  const now = new Date();
  const expired = moment(+tokenExpired).add(29, "minutes");
  return expired.isBefore(now);
};
